import { Environment, environment } from '@repo/environment';

export const getBuildInfo = (): { version: string; shaShort: string; builtAt: string } => {
  if (environment !== Environment.LOCAL) {
    const requiredVars = ['REACT_APP_BUILD_VERSION', 'REACT_APP_BUILD_SHA_SHORT', 'REACT_APP_BUILD_TIME'] as const;

    const missing = requiredVars.filter((v) => !process.env[v]);
    if (missing.length > 0) {
      console.error(`Missing required build environment variables: ${missing.join(', ')}`);
    }
  }

  return {
    version: process.env.REACT_APP_BUILD_VERSION || 'unknown',
    shaShort: process.env.REACT_APP_BUILD_SHA_SHORT || 'unknown',
    builtAt: process.env.REACT_APP_BUILD_TIME || 'unknown',
  };
};
